import { Fragment } from "react";

const Contact = () => {
    return(
        <Fragment>
            <div className="">Contact Pahe</div>
        </Fragment>
    )
}

export default Contact;